// extracted by mini-css-extract-plugin
export default {"closesvg":"CloseSvg_closesvg__KZQUF"};